module.exports = __webpack_public_path__ + "img/title-4.953d6aa2.png";